"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[396],{

/***/ 8396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ulupinar_prefers_UlupinarPrefers; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 6 modules
var gridview = __webpack_require__(8117);
;// CONCATENATED MODULE: ./components/widgets/ulupinar-prefers/UlupinarPrefers.tsx



var UlupinarPrefers = function(param) {
    var title = param.title, description = param.description, data = param.data;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "UlupinarSlider",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Container */.W2, {
            size: "medium",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "UlupinarSlider-head",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        dangerouslySetInnerHTML: {
                            __html: title
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "UlupinarSlider-desc",
                    dangerouslySetInnerHTML: {
                        __html: description
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "Ulupinar-Prefers",
                    children: data.map(function(item, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                            className: "Ulupinar-Prefers-item",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: item.item
                                }
                            })
                        }, index);
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var ulupinar_prefers_UlupinarPrefers = (UlupinarPrefers);

;// CONCATENATED MODULE: ./components/widgets/ulupinar-prefers/index.ts



/***/ })

}]);